import { type LWApiPublicNetworkDnsDomainContactListResult } from '@liquidweb-dev/club-sauce/public/network/dns/domain/contact';
import { type LWApiPublicNetworkDnsDomainContactListParamsRaw } from '@liquidweb-dev/club-sauce/public/network/dns/domain/contact/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import api from 'modules/queries/api';

export const NETWORK_DNS_DOMAIN_CONTACT_LIST_QUERY_KEY =
	'/network/dns/domain/contact/list';

const useNetworkDnsDomainContactList = (
	params: LWApiPublicNetworkDnsDomainContactListParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsDomainContactListResult,
		ApiErrorI,
		LWApiPublicNetworkDnsDomainContactListResult
	>,
) =>
	useQuery({
		queryKey: [NETWORK_DNS_DOMAIN_CONTACT_LIST_QUERY_KEY, params],
		queryFn: () => api.network.dns.domain.contact.list(params),
		...options,
	});

export default useNetworkDnsDomainContactList;
